<template>
    <div id="form-book">
        <div class="wrapper">
            <div class="title">
                <img src="../assets/logo.svg" alt="">
                <p>
                    안녕하세요, 건국대학교 글로컬캠퍼스 시각광고디자인 제 31회 졸업전시, &lt;축하축하전&gt;의 졸업준비위원회입니다.<br>
                    먼저, 저희 전시를 찾아주시고 저희 학생들의 졸업을 축하해주셔서 정말 감사드립니다.<br>
                    저희 &lt;축하축하전&gt;의 도록의 경우, 이전 전시와는 다르게 '후도록'으로 제작하여 보내드립니다.
                    <br><br>
                    <strong>후도록이란?</strong> <br>
                    전시 전에 도록을 완성하여 제공해드리는 게 아닌, 전시 후에 도록을 완성하는 것을 말합니다. <br>
                    아래 신청서 양식에 맞춰 제출해주시면 연락드리며 도록을 전달해드리도록 하겠습니다. <br>
                    약 2019년 12월에 받아보실 수 있을 것입니다.
                    <br><br>
                    궁금한 것이 있으시다면 아래 연락처로 연락 바랍니다. <br>
                    김도현 / 010-7155-2182 / kdhalth@naver.com
                    <br><br>
                    다시 한 번, 저희 전시를 찾아주셔서 감사합니다.
                </p>
            </div>
            <div class="form">
                <p>책을 받고 연락을 받으실 분에 대한 정보를 입력해주세요.</p>
                <input type="text" placeholder="받으시는 분 성함" v-model="writingData.name">
                <input type="text" placeholder="받으실 주소" v-model="writingData.addr">
                <input type="tel" placeholder="연락처" v-model="writingData.tel">
                <p>이곳으로 도록 한 권을 보내드리도록 하겠습니다.</p>
                <button @click="submit(writingData)">신청하기</button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                writingData: {
                    name: ``,
                    addr: ``,
                    tel: ``,
                },
            }
        },
        methods: {
            submit(temp) {
                if ( this.writingData.name === '' || this.writingData.addr === '' || this.writingData.tel === '' || this.writingData.number === '') {
                    alert('신청서의 모든 칸을 작성하셔야 신청이 가능합니다.')
                } else {
                    const submitConfirm = confirm( '이대로 신청할까요?') 
                    if ( submitConfirm == true ) {
                            this.$store.state.db.add({
                                uploadData: temp,
                                date: new Date
                        }).then(function() {
                            alert('신청이 정상적으로 완료되었습니다. 감사합니다.')
                            window.location.reload()
                        }).catch(function(err) {
                            console.log(err)
                    })
                    } else if ( submitConfirm == false ) {
                        
                    }
                }
            },
        },
    }
</script>

<style scoped>
@media all and (max-width: 767px) {
    #form-book {
        width: 92vw;
        margin: 120px auto;
    }
    #form-book .wrapper {
        width: 92vw;
    }
    #form-book .wrapper > div{
        width: 92vw;
        margin: 88px 1vw;
    }

    /* 타이틀 */
    #form-book .wrapper .title {
        margin: 56px auto;
        text-align: center;
    }
    #form-book .wrapper .title img {
        display: none;
    }
    #form-book .wrapper .title p {
        width: 92vw;
        margin: 32px auto;
        text-align: left;
        font-size: 1.1rem;
        line-height: 1.8rem;
        word-break: keep-all;
    }
    #form-book .wrapper .title p strong{
        font-size: 1.4rem;
        font-weight: 900;
    }
    /* 양식 */
    #form-book .wrapper .form {
        text-align: start;
    }
    #form-book .wrapper .form select, #form-book .wrapper .form input {
        display: block;
        margin: 32px auto;
        padding: 1vw;
        border: none;
        border-bottom: 3px solid #ed86a1;
        background: none;
        color: #ed86a1;
        font-size: 2rem;
    }
    #form-book .wrapper .form select {
        color: #000;
        margin: 32px 0;
        background: #ed86a1;
    }
    #form-book .wrapper .form input {
        appearance: none;
        width: 90vw;
    }
    #form-book .wrapper .form button {
        width: 42vw;
        height: 56px;
        font-size: 1.3rem;
        appearance: none;
        border: 0;
        background: none;
        color: #ed86a1;
        border: 2px solid #ed86a1;
    }
    
}
@media all and (min-width: 768px) {
    #form-book {
        width: 96vw;
        margin: 120px auto;
    }
    #form-book .wrapper {
        width: 96vw;
    }
    #form-book .wrapper > div{
        width: 44vw;
        margin: 56px 1vw;
        display: inline-block;
    }

    /* 타이틀 */
    #form-book .wrapper .title {
        margin: 56px auto;
        text-align: center;
    }
    #form-book .wrapper .title img {
        width: 20vw;
    }
    #form-book .wrapper .title p {
        width: 24vw;
        margin: 32px auto;
        text-align: left;
        font-size: 1.1rem;
        line-height: 1.8rem;
        word-break: keep-all;
    }
    #form-book .wrapper .title p strong{
        font-size: 1.4rem;
        font-weight: 900;
    }
    /* 양식 */
    #form-book .wrapper .form {
        height: 50vh;
        text-align: start;
    }
    #form-book .wrapper .form p {
        margin: 32px 0;
    }
    #form-book .wrapper .form input {
        display: block;
        margin: 32px 0;
        padding: 1%;
        border: none;
        border-bottom: 3px solid #ed86a1;
        background: none;
        color: #ed86a1;
        font-size: 2rem;
    }
    #form-book .wrapper .form input {
        appearance: none;
        width: 38vw;
    }
    #form-book .wrapper .form button {
        width: 10vw;
        height: 56px;
        font-size: 1.3rem;
        appearance: none;
        border: 0;
        background: none;
        color: #ed86a1;
        border: 2px solid #ed86a1;
    }
}
    
</style>


// WEBPACK FOOTER //
// src/components/FormBook.vue